import { useEffect, useRef } from 'react';
import { MapRef } from 'react-map-gl';
import WebMercatorViewport from 'viewport-mercator-project';

const useMapResizeObserver = (reactMapGLRef: MapRef | null) => {
  const resizeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }

      resizeTimeoutRef.current = setTimeout(() => {
        if (reactMapGLRef) {
          const map = reactMapGLRef.getMap();
          const mapWidth = map.getContainer().clientWidth;
          const mapHeight = map.getContainer().clientHeight;

          if (!mapWidth || !mapHeight) {
            return;
          }

          const currentViewState = map.getCenter();
          const currentZoom = map.getZoom();

          const viewport = new WebMercatorViewport({
            width: mapWidth,
            height: mapHeight,
            longitude: currentViewState.lng,
            latitude: currentViewState.lat,
            zoom: currentZoom,
          });

          map.resize();
          map.jumpTo({
            center: [viewport.longitude, viewport.latitude],
            zoom: viewport.zoom,
          });
        }
      }, 100);
    };

    const resizeObserver = new ResizeObserver(handleResize);
    const container = reactMapGLRef?.getMap().getContainer();

    if (container) {
      resizeObserver.observe(container);
    }

    return () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      resizeObserver.disconnect();
    };
  }, [reactMapGLRef]);
};

export default useMapResizeObserver;
